<!--  Only Large and Normal Desktop HTML5 Goes here... -->
<div *ngIf='screenWidth > 1230'>
    <!-- <div class="visible-lg" (window:orientationchange)="screenRotate($event)"> -->

  <div (window:orientationchange)="screenRotate($event)">
    <div class="bmw-faq-card">
      <div class="flex-container row">
        <div class="flex-50">
          <div class="bmw-faq-faq">
            <div class="bmw-faq-title">
              FAQ
            </div>
            <div class="bmw-faq-links">
              <div *ngFor='let link of faqLinks'>
                <a [href]="(link?.documentFileName!=null && link?.documentFileName?.startsWith('http')) ? link?.documentFileName : 'http://'+ link?.documentFileName" target="_blank" *ngIf="link?.attachmentType === 'Link'" (click)='saveToAnalytics(link?.documentTitle)'>
                  <div class="bmw-faq-link" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>{{link?.documentTitle}}</div>
                </a>
                <a [href]='"mount/faq_and_top_link/"+link?.documentFileName' target="_blank" *ngIf="link?.attachmentType === 'File'" (click)='saveToAnalytics(link?.documentTitle)'>
                  <div class="bmw-faq-link" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>{{link?.documentTitle}}</div>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="flex-50">
          <div class="bmw-faq-top-links">
            <div class="bmw-faq-title">
              Top Links
            </div>
            <div class="bmw-faq-links">
              <div *ngFor='let link of topLinks'>
                <a [href]="(link?.documentFileName!=null && link?.documentFileName?.startsWith('http')) ? link?.documentFileName : 'http://'+ link?.documentFileName" target="_blank" *ngIf="link?.attachmentType === 'Link'" (click)='saveToAnalytics(link?.documentTitle)'>
                  <div class="bmw-faq-link" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>{{link?.documentTitle}}</div>
                </a>
                <a [href]='"mount/faq_and_top_link/"+link?.documentFileName' target="_blank" *ngIf="link?.attachmentType === 'File'" (click)='saveToAnalytics(link?.documentTitle)'>
                  <div class="bmw-faq-link" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>{{link?.documentTitle}}</div>
                </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</div>
<!--  Only iPadPro and Medium size Desktop HTML5 Goes here... -->

<div *ngIf='screenWidth >= 991 && screenWidth <= 1230'>
  <!-- <div class="visible-md" (window:orientationchange)="screenRotate($event)"> -->

  <div  (window:orientationchange)="screenRotate($event)">
    <div class="bmw-md bmw-faq-card">
      <div class="flex-container row">
        <div class="flex-50">
          <div class="bmw-faq-faq">
            <div class="bmw-faq-title">
              FAQ
            </div>
            <div class="bmw-faq-links">
              <div *ngFor='let link of faqLinks'>
                <a [href]="(link?.documentFileName!=null && link?.documentFileName?.startsWith('http')) ? link?.documentFileName : 'http://'+ link?.documentFileName" target="_blank" *ngIf="link?.attachmentType === 'Link'">
                  <div class="bmw-faq-link" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>{{link?.documentTitle}}</div>
                </a>
                <a [href]='"mount/faq_and_top_link/"+link?.documentFileName' target="_blank" *ngIf="link?.attachmentType === 'File'">
                  <div class="bmw-faq-link" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>{{link?.documentTitle}}</div>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="flex-50">
          <div class="bmw-faq-top-links">
            <div class="bmw-faq-title">
              Top Links
            </div>
            <div class="bmw-faq-links">
              <div *ngFor='let link of topLinks'>
                <a [href]="(link?.documentFileName!=null && link?.documentFileName?.startsWith('http')) ? link?.documentFileName : 'http://'+ link?.documentFileName" target="_blank" *ngIf="link?.attachmentType === 'Link'">
                  <div class="bmw-faq-link" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>{{link?.documentTitle}}</div>
                </a>
                <a [href]='"mount/faq_and_top_link/"+link?.documentFileName' target="_blank" *ngIf="link?.attachmentType === 'File'">
                  <div class="bmw-faq-link" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>{{link?.documentTitle}}</div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!--  Only Tablet or iPad HTML5 Goes here... -->
<div *ngIf='screenWidth >= 767 && screenWidth <= 991'>
  <!-- <div class="visible-sm" (window:orientationchange)="screenRotate($event)"> -->

  <div (window:orientationchange)="screenRotate($event)">
    <div class="bmw-sm bmw-faq-card">
      <div class="flex-container row">
        <div class="flex-50">
          <div class="bmw-faq-faq">
            <div class="bmw-faq-title">
              FAQ
            </div>
            <div class="bmw-sm-faq-links">
              <div *ngFor='let link of faqLinks'>
                <a [href]="(link?.documentFileName!=null && link?.documentFileName?.startsWith('http')) ? link?.documentFileName : 'http://'+ link?.documentFileName" target="_blank" *ngIf="link?.attachmentType === 'Link'">
                  <div class="bmw-faq-link" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>{{link?.documentTitle}}</div>
                </a>
                <a [href]='"mount/faq_and_top_link/"+link?.documentFileName' target="_blank" *ngIf="link?.attachmentType === 'File'">
                  <div class="bmw-faq-link" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>{{link?.documentTitle}}</div>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="flex-50">
          <div class="bmw-faq-top-links">
            <div class="bmw-faq-title">
              Top Links
            </div>
            <div class="bmw-sm-faq-links">
              <div *ngFor='let link of topLinks'>
                <a [href]="(link?.documentFileName!=null && link?.documentFileName?.startsWith('http')) ? link?.documentFileName : 'http://'+ link?.documentFileName" target="_blank" *ngIf="link?.attachmentType === 'Link'">
                  <div class="bmw-faq-link" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>{{link?.documentTitle}}</div>
                </a>
                <a [href]='"mount/faq_and_top_link/"+link?.documentFileName' target="_blank" *ngIf="link?.attachmentType === 'File'">
                  <div class="bmw-faq-link" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>{{link?.documentTitle}}</div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!--  Only Mobile HTML5 Goes here... -->
<div *ngIf='screenWidth > 319 && screenWidth < 767'>
  <!-- <div class="visible-xs" (window:orientationchange)="screenRotate($event)"> -->

  <div (window:orientationchange)="screenRotate($event)">
    <div class="bmw-xs bmw-faq-card">
      <div class="bmw-faq-faq">
        <div class="bmw-xs bmw-faq-title">
          FAQ
        </div>
        <div class="bmw-xs-faq-links">
          <div *ngFor='let link of faqLinks'>
            <a [href]="(link?.documentFileName!=null && link?.documentFileName?.startsWith('http')) ? link?.documentFileName : 'http://'+ link?.documentFileName" target="_blank" *ngIf="link?.attachmentType === 'Link'">
              <div class="bmw-faq-link" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>{{link?.documentTitle}}</div>
            </a>
            <a [href]='"mount/faq_and_top_link/"+link?.documentFileName' target="_blank" *ngIf="link?.attachmentType === 'File'">
              <div class="bmw-faq-link" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>{{link?.documentTitle}}</div>
            </a>
          </div>
        </div>
      </div>
      <div class="bmw-xs-faq-top-links">
        <div class="bmw-xs bmw-faq-title">
          Top Links
        </div>
        <div class="bmw-xs-faq-links">
          <div *ngFor='let link of topLinks'>
            <a [href]="(link?.documentFileName!=null && link?.documentFileName?.startsWith('http')) ? link?.documentFileName : 'http://'+ link?.documentFileName" target="_blank" *ngIf="link?.attachmentType === 'Link'">
              <div class="bmw-faq-link" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>{{link?.documentTitle}}</div>
            </a>
            <a [href]='"mount/faq_and_top_link/"+link?.documentFileName' target="_blank" *ngIf="link?.attachmentType === 'File'">
              <div class="bmw-faq-link" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>{{link?.documentTitle}}</div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>